import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from './views/Login.vue';
import AuthCheck from './views/AuthCheck.vue';
import MyLists from './views/MyLists.vue';
import ViewList from './views/ViewList.vue';
import ViewAccount from './views/ViewAccount.vue';
import OauthSignIn from './views/OauthSignIn.vue';

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'SmartShoppingList',
      component: AuthCheck
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/lists',
      name: 'My Lists',
      component: MyLists
    },
    {
      path: '/list/view/:id',
      name: 'View List',
      component: ViewList
    },
    {
      path: '/account',
      name: 'View Account',
      component: ViewAccount
    },
    {
      path: '/oauth',
      name: 'Oauth SignIn',
      component: OauthSignIn
    }
  ]
});
